import { updateObject } from 'utils/updateObject'
import { YANDEX_SUBSCRIPTION_CAMPAIGN_SET_DATA } from 'modules/Services/types'

const initialState = {
  loading: true,
  campaign: {},
}

const campaignSetData = (state, { payload }) => {
  return updateObject(state, payload)
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case YANDEX_SUBSCRIPTION_CAMPAIGN_SET_DATA:
      return campaignSetData(state, action)
    default:
      return state
  }
}

export default reducer
